module.exports = __webpack_public_path__ + "static/media/popup2-min.0603188f.png";